import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext.tsx';
import SettingsSidebar from '../../features/settings/components/SettingsSidebar';

const SettingsLayout: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Settings</h1>
        <p className="text-gray-600">
          Manage your account, preferences, and privacy settings
        </p>
      </div>

      <div className="lg:grid lg:grid-cols-12 lg:gap-x-8">
        {/* Sidebar Navigation */}
        <SettingsSidebar user={user!} />

        {/* Main Content - Child routes render here */}
        <main className="lg:col-span-9">
          <div className="py-6 px-4 sm:p-6 lg:pb-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default SettingsLayout; 